package org.example.project.ui.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.example.project.client.session.SessionState
import org.example.project.ui.icons.AppIcons
import org.example.project.ui.theme.EditorColors

@Composable
fun EditorHeader(
    sessionState: SessionState,
    sectionTitle: String,
    onLogout: () -> Unit,
    appTitle: String = "Panel Redaktora",
    isMobile: Boolean = false,
    isMobileMenuOpen: Boolean = false,
    onToggleMobileMenu: (() -> Unit)? = null,
    modifier: Modifier = Modifier
) {
    Surface(
        modifier = modifier
            .fillMaxWidth()
            .height(64.dp),
        color = EditorColors.Surface,
        border = BorderStroke(1.dp, EditorColors.BorderSubtle)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = if (isMobile) 16.dp else 24.dp),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            // Left: Title or mobile menu trigger
            Row(verticalAlignment = Alignment.CenterVertically) {
                if (isMobile && onToggleMobileMenu != null) {
                    Surface(
                        shape = RoundedCornerShape(8.dp),
                        color = if (isMobileMenuOpen) EditorColors.SurfaceSubtle else EditorColors.Surface,
                        border = BorderStroke(1.dp, EditorColors.Border),
                        modifier = Modifier
                            .clickable { onToggleMobileMenu() }
                            .padding(end = 12.dp)
                    ) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier.padding(horizontal = 8.dp, vertical = 6.dp)
                        ) {
                            Icon(
                                imageVector = if (isMobileMenuOpen) AppIcons.Close else AppIcons.Catalog,
                                contentDescription = if (isMobileMenuOpen) "Zamknij menu" else "Otwórz menu",
                                tint = EditorColors.TextPrimary,
                                modifier = Modifier.size(18.dp)
                            )
                        }
                    }
                }

                if (!isMobile) {
                    Text(
                        text = appTitle,
                        color = EditorColors.TextMuted,
                        fontSize = 13.sp,
                        fontWeight = FontWeight.Medium
                    )
                    Text(
                        text = " / ",
                        color = EditorColors.BorderStrong,
                        fontSize = 13.sp,
                        modifier = Modifier.padding(horizontal = 6.dp)
                    )
                }

                Text(
                    text = sectionTitle,
                    color = EditorColors.TextPrimary,
                    fontSize = if (isMobile) 16.sp else 15.sp,
                    fontWeight = FontWeight.SemiBold
                )
            }

            // Right: User profile info & logout
            if (sessionState is SessionState.AuthenticatedWeb) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    if (!isMobile) {
                        // User Avatar circle
                        Surface(
                            shape = RoundedCornerShape(999.dp),
                            color = EditorColors.PrimarySubtle,
                            border = BorderStroke(1.dp, EditorColors.PrimaryBorder),
                            modifier = Modifier.size(36.dp)
                        ) {
                            Column(
                                horizontalAlignment = Alignment.CenterHorizontally,
                                verticalArrangement = Arrangement.Center
                            ) {
                                val initials = sessionState.user.displayName
                                    .take(2)
                                    .uppercase()
                                Text(
                                    text = initials,
                                    fontSize = 12.sp,
                                    fontWeight = FontWeight.Bold,
                                    color = EditorColors.Primary
                                )
                            }
                        }

                        Spacer(modifier = Modifier.width(10.dp))

                        Column(horizontalAlignment = Alignment.Start) {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Text(
                                    text = sessionState.user.displayName,
                                    color = EditorColors.TextPrimary,
                                    fontWeight = FontWeight.SemiBold,
                                    fontSize = 13.sp
                                )
                                if (sessionState.user.roles.contains("admin")) {
                                    Spacer(modifier = Modifier.width(6.dp))
                                    Surface(
                                        shape = RoundedCornerShape(999.dp),
                                        color = EditorColors.PrimarySubtle,
                                        border = BorderStroke(1.dp, EditorColors.PrimaryBorder)
                                    ) {
                                        Text(
                                            text = "ADMIN",
                                            color = EditorColors.Primary,
                                            fontSize = 9.sp,
                                            fontWeight = FontWeight.Bold,
                                            modifier = Modifier.padding(horizontal = 6.dp, vertical = 2.dp)
                                        )
                                    }
                                }
                            }
                            sessionState.user.email?.let { email ->
                                Text(
                                    text = email,
                                    color = EditorColors.TextMuted,
                                    fontSize = 11.sp
                                )
                            }
                        }

                        Spacer(modifier = Modifier.width(16.dp))
                    }

                    OutlinedButton(
                        onClick = onLogout,
                        shape = RoundedCornerShape(8.dp),
                        colors = ButtonDefaults.outlinedButtonColors(
                            contentColor = EditorColors.TextSecondary
                        ),
                        border = BorderStroke(1.dp, EditorColors.Border),
                        contentPadding = ButtonDefaults.ContentPadding
                    ) {
                        Text(
                            text = "Wyloguj",
                            fontSize = 12.sp,
                            fontWeight = FontWeight.Medium
                        )
                    }
                }
            }
        }
    }
}
